import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { AtylTextArea } from '../../../../../motor-form-atyl/atyl-input-components/atyl-input-components'
import { FormAtylBase } from '../../../../../motor-form-atyl/form-atyl-base'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'


@Component({
	selector: 'atyl-form-input-textarea',
	templateUrl: './form-input-textarea.component.html',
	styleUrls: ['./form-input-textarea.component.scss']
})
export class FormInputTextareaComponent implements OnInit {

	@Input() forminput: FormAtylBase<AtylTextArea>
	@Input() group: FormGroup
	@Input() isValid: boolean
	@Input() errorMessage: string | undefined | null
	@Input() outline: boolean
	@Input() disabled: boolean

	@Output() inputTyped = new EventEmitter<any>();
	label: string
	errorString: string
	
	configHTML: any = {
        height: '250px',
        width: '100%',
        toolbar: [
            
            ['style', ['bold', 'italic', 'underline']],
            ['para', ['ul', 'ol', 'paragraph', 'height']],
            ['insert', ['table']],
            
        ],
        buttons: {
           
          }
    };
	
	rows:number=5;
	
	constructor(
		private readonly inputLabelPipe: InputLabelPipe
	) { }

	ngOnInit(): void {
		//console.log('textarea ishtml',this.forminput);
		        
        if (this.forminput.placeholder)
           this.configHTML["placeholder"]=this.forminput.placeholder;
        if (this.forminput.options!=undefined) {
			if (this.forminput.options.rows!=undefined) {
				this.rows=this.forminput.options.rows;
			}
			
			if (this.forminput.options.summernote!=undefined) {
				this.configHTML = Object.assign(this.configHTML, this.forminput.options.summernote);
			}
						
		}
       // console.log('textarea ishtml',this.forminput);
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
	}

	customBehaviourHandler(customBehaviour: any) {
		this.inputTyped.emit(customBehaviour)
	}
	replaceValue(newValue: any) {
		this.group.get(String(this.forminput.ID)).setValue(newValue.value)
	}
}
